module.exports = __webpack_public_path__ + "static/websiteportrait-54295c91b7607e88e500e21a6eacae9c.png";